export const BOARD_CONNECTION_STATE_CONNECTED = 'BOARD_CONNECTION_STATE_CONNECTED'
export const BOARD_CONNECTION_STATE_CONNECTING = 'BOARD_CONNECTION_STATE_CONNECTING'
export const BOARD_CONNECTION_STATE_RECONNECTING = 'BOARD_CONNECTION_STATE_RECONNECTING'
export const BOARD_CONNECTION_STATE_DISCONNECTED = 'BOARD_CONNECTION_STATE_DISCONNECTED'
export const BOARD_CONNECTION_STATE_DISCONNECTING = 'BOARD_CONNECTION_STATE_DISCONNECTING'
export const BOARD_CONNECTION_STATE_FAILED = 'BOARD_CONNECTION_STATE_FAILED'
export const BOARD_CONNECTION_STATE_UNINITIALIZED = 'BOARD_CONNECTION_STATE_UNINITIALIZED'
export const BOARD_CONNECTION_STATE_ALREADY_IN_USE = 'BOARD_CONNECTION_STATE_ALREADY_IN_USE'
export const BOARD_CONNECTION_STATE_SUSHI_ERROR = 'BOARD_CONNECTION_STATE_SUSHI_ERROR'
